import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useStoreDispatch, useStoreSelector } from "../../../../../../../hooks/StoreHooks";
import { usePergolaConfigurationBuilderActions } from "../../../../../../../store/reducers/pergola_configuration_builder";
import { IlluminationType } from "../../../../../../models/pergola_configuration";

type Props = {
  lato: "Retro" | "Fronte" | "Destra" | "Sinistra";
};

export const LedChoice = ({ lato }: Props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useStoreDispatch();
  const { pergolaConfigurationBuilder } = useStoreSelector((store) => store);
  const { setStepActive, setStepComplete, setPergolaSide, toggleLed } = usePergolaConfigurationBuilderActions();
  const latoScelto = pergolaConfigurationBuilder.led.find((l) => l.direzione === lato) || { direzione: lato, tipo: IlluminationType.nessuno };
  const [isSubmit, setIsSubmit] = useState(false);

  useEffect(() => {
    if (!id || isNaN(Number(id)) || !pergolaConfigurationBuilder.configuration) {
      navigate("/configurations");
    } else {
      dispatch(setStepActive({ stepSlug: "illuminazioni", isActive: true }));
    }
  }, [id, navigate, pergolaConfigurationBuilder.configuration, pergolaConfigurationBuilder.led, dispatch, setStepActive]);

  const handleChange = (field: string, value: IlluminationType) => {
    dispatch(toggleLed({ direzione: lato, tipo: value }));
  };

  const submit = async () => {
    setIsSubmit(true);
    try {
      dispatch(setStepComplete({ stepSlug: "illuminazioni", isComplete: true }));
      navigate(`/pergola-configurations/${id}/next-step`);
    } catch (e: any) {
      setIsSubmit(false);
      alert(`Errore: ${e?.message || e}`);
    }
  };

  return (
    <div className="row h-full m-0">
      <div className="p-4">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            submit();
          }}
        >
          <FormControl fullWidth className="mt-2">
            <InputLabel id="kitLed-label">Kit Led</InputLabel>
            <Select
              labelId="kitLed-label"
              id="kitLed"
              name="kitLed"
              label="Kit Led"
              value={latoScelto.tipo || IlluminationType.nessuno}
              onChange={(e) => handleChange("kitLed", e.target.value as IlluminationType)}
            >
              <MenuItem value={IlluminationType.led_freddo}>Luce Naturale</MenuItem>
              <MenuItem value={IlluminationType.led_caldo}>Luce calda</MenuItem>
              <MenuItem value={IlluminationType.led_rgb}>Luce RGB</MenuItem>
              <MenuItem value={IlluminationType.nessuno}>Nessun Led</MenuItem>
            </Select>
          </FormControl>
        </form>
      </div>
    </div>
  );
};